<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader title="Insight" subtitle="Hawaii State Environmental Health Administration" light />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop light class="grid grid-cols-1 gap-10">
        <PublicLandingOnlineServices
          class=""
          title="Employee Services"
          body="The Insight app provides online employee access to Environmental Health Administration grants, contracts, and projects."
          hide-register
        ></PublicLandingOnlineServices>

        <PublicLandingCard>
          <PublicLandingCardSection label="Grants">
            <PublicLandingParagraph
              >Find, view, and manage federal, state, and local grants awarded to the Environmental Health
              Administration.</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Track submitted, awarded, and denied grant applications" />
              <PublicLandingListItem label="Manage grant contacts, documents, and notes" />
              <PublicLandingListItem label="Monitor projects funded by grant awards" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Contracts">
            <PublicLandingParagraph
              >Find, view, and manage contracts executed by the Environmental Health
              Administration.</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Track pending, active, expired, and terminated contracts" />
              <PublicLandingListItem label="Manage contract modifications, documents and notes" />
              <PublicLandingListItem label="Monitor projects executed within the contract" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Projects">
            <PublicLandingParagraph
              >Find, view, and manage Environmental Health Administration projects.</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Track project ETS-205 forms, purchase orders, and contract task orders" />
              <PublicLandingListItem label="Manage project deliverables, invoices, documents, and notes" />
              <PublicLandingListItem label="Access contract and grant data for the project" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>
    <MdrnFooter light black-and-white />
  </div>
</template>

<script lang="ts">
import { MdrnFooter, useAppSettingsStore } from "@modernary/mui/components/common";

import { defineComponent } from "vue";

import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { appSettingsStore };
  },
  components: {
    MdrnFooter,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #684945; /* average color from the sky of the bg */
  background-image: url("/images/bg-public.jpg");
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
}
</style>
